import Vue from 'vue'
import Router from 'vue-router'
import S404 from "@/pages/S404"
import Home from "@/pages/Home"
import Login from "@/pages/Login/Login"
import accountAdmin from "@/pages/Login/add"


import diyIndex from "@/pages/DIY/index"



import user from "@/pages/userAdmin/index"


// 品牌
import brand from "@/pages/brand/index"



// 意见反馈
import feedback from "@/pages/feedback/index"


// 常见问题
import problem from "@/pages/problem/index"



// 常见问题
import logistics from "@/pages/logistics/index"




// 商品订单
import consignmentOrder from "@/pages/goodsOrder/consignmentOrder"
import verificationOrder from "@/pages/goodsOrder/verificationOrder"





//基础设置
import Recharge from "@/pages/RechargeAdmin/add"
import logisticsMoney from "@/pages/RechargeAdmin/logisticsMoney"

//批号查询管理
import brandLogic from "@/pages/batchQuery/brandLogic"
import noBrandQueryRecord from "@/pages/batchQuery/noBrandQueryRecord"
import contributionBatchTable from "@/pages/batchQuery/contributionBatchTable"
import typeSearchMiss from "@/pages/batchQuery/typeSearchMiss"









Vue.use(Router)

//初始路由
let routes0 = [
    {
        path: '/Login',
        component: Login,
        name: '登陆',
        hidden: true
    },
    {
        path: '*',
        component: S404,
        name: '404',
        hidden: true
    }
];



// 总平台权限
var adminData = [
    {
        path: '/goodsOrder/consignmentOrder',
        component: Home,
        name: '寄售订单',
        iconCls: '',
        leaf: false,
        children: [
            {
                path: '/goodsOrder/consignmentOrder',
                component: consignmentOrder,
                name: '寄售订单'
            }
        ]
    },
    {
        path: '/goodsOrder/verificationOrder',
        component: Home,
        name: '鉴别订单',
        iconCls: '',
        leaf: false,
        children: [
            {
                path: '/goodsOrder/verificationOrder',
                component: verificationOrder,
                name: '鉴别订单'
            }
        ]
    },
    {
        path: '/brand',
        component: Home,
        name: '品牌管理',
        iconCls: '',
        leaf: false,
        children: [
            {
                path: '/brand',
                component: brand,
                name: '品牌管理'
            }
            
        ]
    },
    {
        path: '/user',
        component: Home,
        name: '用户管理',
        iconCls: '',
        leaf: false,
        children: [
            {
                path: '/user',
                component: user,
                name: '用户管理'
            }
            
        ]
    },

    {
        path: '/Recharge/add',
        component: Home,
        name: '基本设置',
        iconCls: '',
        leaf: true,
        children: [        
            {
                path: '/Recharge/add',
                component: Recharge,
                name: '基本设置'
            },
            {
                path: '/Recharge/logisticsMoney',
                component: logisticsMoney,
                name: '鉴别价格'
            }
        ]
    },
    {
        path: '/batchQuery/brandLogic',
        component: Home,
        name: '品牌批号查询管理',
        iconCls: '',
        leaf: true,
        children: [
            {
                path: '/batchQuery/brandLogic',
                component: brandLogic,
                name: '品牌逻辑列表'
            },
            {
                path: '/batchQuery/contributionBatchTable',
                component: contributionBatchTable,
                name: '贡献批号列表'
            },
            {
                path: '/batchQuery/noBrandQueryRecord',
                component: noBrandQueryRecord,
                name: '无品牌逻辑查询记录'
            },
            {
                path: '/batchQuery/typeSearchMiss',
                component: typeSearchMiss,
                name: '品牌搜索无结果'
            }
        ]
    },
    {
        path: '/feedback',
        component: Home,
        name: '反馈意见',
        iconCls: '',
        leaf: false,
        children: [
            {
                path: '/feedback',
                component: feedback,
                name: '反馈意见'
            }
            
        ]
    },
    {
        path: '/problem',
        component: Home,
        name: '常见问题',
        iconCls: '',
        leaf: false,
        children: [
            {
                path: '/problem',
                component: problem,
                name: '常见问题'
            }
            
        ]
    },
    {
        path: '/',
        component: Home,
        name: '界面管理',
        iconCls: '',
        leaf: false,
        children: [
            {
                path: '/index',
                component: diyIndex,
                name: '轮播图'
            },
        
        ]
    },
    {
        path: '/logistics',
        component: Home,
        name: '物流公司',
        iconCls: '',
        leaf: false,
        children: [
            {
                path: '/logistics',
                component: logistics,
                name: '物流公司'
            }
            
        ]
    },
      {
        path: '/accountAdmin',
        component: Home,
        name: '密码设置',
        iconCls: '',
        leaf: false,
        children: [
            {
                path: '/accountAdmin',
                component: accountAdmin,
                name: '密码设置'
            }
            
        ]
    },


   

  
    // {
    //     path: '/',
    //     component: Home,
    //     name: '招聘求职',
    //     iconCls: '',
    //     leaf: true,
    //     children: [
    //         {
    //             path: '/recruit',
    //             component: recruit,
    //             name: '待审核'
    //         },
    //         {
    //             path: '/recruitInfo',
    //             component: recruitInfo,
    //             name: '招聘求职'
    //         }
    //     ]
    // },
 
  
  
];


// 子商户
var adminData2 = [
  
]




export default new Router({
    routes: routes0
})


function getRoute(type) {
    if(type == 1){
        // 平台管理权限
        return adminData
    } if(type == 2){
        // 子商户
        return adminData2
    }else{
        // 未登陆
        return routes0
    }
   
}



export {getRoute};


// WEBPACK FOOTER //
// ./src/router/index.js